/**
 * Forces multi-word table headings onto two predictable lines. The first word
 * is the first line and the complete remainder is the second line.
 */
export function formatTwoLineTableHeader(label: string): string {
  const normalized = label.trim().replace(/\s+/g, ' ');
  const firstSpace = normalized.indexOf(' ');

  if (firstSpace < 0) {
    return normalized;
  }

  return `${normalized.slice(0, firstSpace)}\n${normalized.slice(
    firstSpace + 1,
  )}`;
}

const LVO_ROLE_SUFFIX = ' LVO';

/**
 * Users table role column headers. Paired LVO roles lead with "LVO" so they are
 * not confused with the base role (e.g. Partner vs Partner Contributor LVO).
 */
export function formatRoleColumnHeader(roleName: string): string {
  const normalized = roleName.trim().replace(/\s+/g, ' ');
  if (normalized.endsWith(LVO_ROLE_SUFFIX)) {
    const baseRole = normalized.slice(0, -LVO_ROLE_SUFFIX.length);
    return `LVO\n${baseRole}`;
  }
  return formatTwoLineTableHeader(normalized);
}
